import { render, staticRenderFns } from "./core_image.vue?vue&type=template&id=24941cf8&scoped=true"
import script from "./core_image.vue?vue&type=script&lang=js"
export * from "./core_image.vue?vue&type=script&lang=js"
import style0 from "./core_image.vue?vue&type=style&index=0&id=24941cf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24941cf8",
  null
  
)

export default component.exports